import {
  GDL_INIT,
  GDL_INIT_SUCCESS,
  GDL_INIT_FAILURE,
  GDL_QUIT,
  GDL_QUIT_SUCCESS,
  GDL_QUIT_FAILURE,
  GDL_RESET,
  GDL_RESET_SUCCESS,
  GDL_RESET_FAILURE,
} from '../constants/app';
import { modal } from './notification';

export const API_ACTION = 'API_ACTION';
export const GDL_ACTION = 'GDL_ACTION';

export const apiAction = (types, promise, params) => ({
  type: API_ACTION,
  types,
  promise,
  ...params,
});

export const gdlAction = (types, promise, params) => ({
  type: GDL_ACTION,
  types,
  promise,
  ...params,
});

export const initGdlAction = () => (dispatch, getState) => {
  const {
    app: { code },
    auth: { studentId, groupId, studentIdNumber },
  } = getState();

  // if studentId or groupId are null, dispatch a modal instructing to reload the page
  if (!studentId || !groupId) {
    dispatch(
      modal(
        'Error',
        'Invalid student or group ID was found. Please log out, reload the page, and log in again.',
        undefined,
        { backdrop: true }
      )
    );
    return;
  }

  dispatch({
    type: GDL_INIT,
    types: [GDL_INIT, GDL_INIT_SUCCESS, GDL_INIT_FAILURE],
    promise: (gdl) =>
      gdl.initializeSession(code, studentId, groupId, studentIdNumber),
  });
};

export const quitGdlAction = () => (dispatch) => {
  dispatch({
    type: GDL_QUIT,
    types: [GDL_QUIT, GDL_QUIT_SUCCESS, GDL_QUIT_FAILURE],
    promise: (gdl) => gdl.quitSession(),
  });
};

export const resetGdlAction = () => (dispatch) => {
  dispatch(
    gdlAction([GDL_RESET, GDL_RESET_SUCCESS, GDL_RESET_FAILURE], (gdl) =>
      gdl.resetSession()
    )
  );
};
